/**
 * The brand this deployment wears. Every user-visible product name, tagline
 * and brand colour in the frontend reads from here so a rebrand is one file,
 * not a grep. The backend keeps its own copy in backend/src/brand.js (PDFs and
 * Copilot preamble) — keep the two in step.
 */
export const BRAND = Object.freeze({
  name: 'BrickBiyte',
  tagline: 'Real Estate · Digital Transformation',
  market: 'Bengaluru',
  // The eight blocks of the mark, top to bottom, left to right.
  blocks: Object.freeze({
    crimson: '#b81848',
    orange: '#f09820',
    magenta: '#e81870',
    yellow: '#f8d810',
    green: '#28b070',
    lime: '#90c038',
    blue: '#1070b8',
    purple: '#602890',
  }),
  navy: '#011341',
});

/** The blocks in the order the cover's colour stripe runs them. */
export const BRAND_STRIPE = Object.freeze([
  BRAND.blocks.crimson,
  BRAND.blocks.orange,
  BRAND.blocks.magenta,
  BRAND.blocks.yellow,
  BRAND.blocks.green,
  BRAND.blocks.lime,
  BRAND.blocks.blue,
  BRAND.blocks.purple,
]);
